export default __webpack_public_path__ + "award_silver.2ebc5e3f.png";